// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__vE0Yo","arrow":"tooltip_arrow__6LONW","tooltip-ellipsis":"tooltip_tooltip-ellipsis__xRgRT"};